import getFeature from "@template/helpers/getFeature";

const getMarketplaceMVTMetadata = async () => {
  const marketplaceMVTDesktopInstance = await getFeature(
    "emf-95-desktop-marketplace-clothing-nav-edit"
  );
  const marketplaceMVTDesktopBucket = marketplaceMVTDesktopInstance?.getVariables()
    ?.bucket;

  const marketplaceMVTMobileInstance = await getFeature(
    "emf-137-mweb-marketplace-clothing-nav-edit"
  );
  const marketplaceMVTMobileBucket = marketplaceMVTMobileInstance?.getVariables()
    ?.bucket;

  return {
    marketplaceMVTDesktopInstance,
    marketplaceMVTDesktopBucket,
    marketplaceMVTMobileInstance,
    marketplaceMVTMobileBucket
  };
};

export default getMarketplaceMVTMetadata;
